import React, { useEffect, useState  } from 'react';
import TextPlayer from './TextPlayer.js'

const SpeakFromExistingText = ({ textId, words }) => {
  const [paras, setParas] = useState([])
  const [playing, setPlaying] = useState(false)
  const [playingParaIndex, setPlayingParaIndex] = useState(0)
  const [speed, setSpeed] = useState(1)
  const [gap, setGap] = useState(0.1)

  useEffect(() => {
    if (textId) {
      fetch(`/texts/${textId}_root-pli-ms.json`)
        .then(response => response.json())
        .then(data => {
          setParas([...Object.values(data)])
        })
    }
  }, [textId, setParas])

  const onEnded = () => {
    setPlayingParaIndex(playingParaIndex + 1)
  }

  return <div>
    <div>
      <input type="number" value={gap} onChange={(e) => setGap(e.target.value)} min={0.0} max={0.5} step={0.01} />
      <button 
        className='button'
        onClick={() => {
          setPlaying(!playing)
        }}
      >
        {playing ? 'Pause' : 'Speak'}
      </button>
    </div>
    <div className='paragraphs'>
      {words && words.length > 0 && paras && paras.length > 0 && paras.map((para, i) => <TextPlayer 
        text={para} 
        key={`para${i}`}
        active={playingParaIndex === i}
        paused={!playing}
        words={words} 
        speed={speed}
        gap={gap}
        onEnded={onEnded} 
        onClick={() => setPlayingParaIndex(i)}
      />)}
    </div>
  </div>
}

export default SpeakFromExistingText

